import type { FinancialAdvisorsSummaryTableEntityType } from '@ria-client/supergraph/structuredContent/hydration/FinancialAdvisorsSummaryTable/types';
import { RatingSummary } from '@ria-client/tw-shared-ui';
import { NW_RATING_DEFAULT_TOOLTIP } from '../lib/financial-advisors/constants';
import { OfferCta } from './offer-cta';

export interface TableRowLearnMoreProps {
  marketplaceEntity: FinancialAdvisorsSummaryTableEntityType;
  index: number;
  className?: string;
  fullLine?: boolean;
  monetizingCtaLabel?: string;
  displayAdLabel?: boolean;
}

export function TableRowLearnMore({
  marketplaceEntity,
  index,
  className,
  fullLine = false,
  monetizingCtaLabel,
  displayAdLabel,
}: TableRowLearnMoreProps) {
  return (
    <tr className={`border-b border-border lg:border-b-0 ${className ?? ''}`}>
      <td
        className="sticky left-0 max-w-[210px] border-b border-border p-0 pr-2 md:relative md:max-w-none lg:border-b-0"
        colSpan={fullLine ? 2 : undefined}
      >
        <div className="flex items-center justify-between">
          {fullLine ? (
            <div className="pb-16">
              <RatingSummary
                layout="horizontal"
                reviewLink={marketplaceEntity.reviewLink}
                starRating={marketplaceEntity.starRating}
                starRatingTooltip={marketplaceEntity.starRatingTooltip ?? NW_RATING_DEFAULT_TOOLTIP}
              />
            </div>
          ) : null}
          <OfferCta
            displayAdLabel={displayAdLabel}
            index={index}
            marketplaceEntity={marketplaceEntity}
            monetizingCtaLabel={monetizingCtaLabel}
          />
        </div>
      </td>
      {fullLine ? null : (
        <td className="w-full border-b border-border p-0 pr-2 lg:border-b-0" colSpan={2} />
      )}
    </tr>
  );
}
